import { priorityIdSchema } from '../../priority/index.js';
import { nullableUuidString } from '../../zod-helpers/index.js';
import { plannedShipDateSchema } from '../ship-date-input.js';
import { deliveryDriverUserIdSchema } from './delivery-driver-user-id-schema.js';
import { deliveryTypeIdSchema } from './delivery-type-id-schema.js';
// Nullable columns: omitted leaves the value, null clears it; priority_id is NOT NULL so it is present-if-touched.
export const updateSalesOrderDeliveryFieldsShape = {
    // The pairing with the stored type is checked on the merged result, server-side (N37).
    deliveryTypeId: deliveryTypeIdSchema.nullable().optional(),
    deliveryDriverUserId: deliveryDriverUserIdSchema.optional(),
    carrierId: nullableUuidString('Invalid carrier selection.').optional(),
    carrierServiceId: nullableUuidString('Invalid carrier service selection.').optional(),
    shipTermsId: nullableUuidString('Invalid ship terms selection.').optional(),
    fobPointId: nullableUuidString('Invalid FOB point selection.').optional(),
    priorityId: priorityIdSchema.optional(),
    shipDate: plannedShipDateSchema.nullable().optional(),
};
//# sourceMappingURL=update-sales-order-delivery-fields-shape.js.map